import { QueryClientProvider } from "@tanstack/react-query";
import { createQueryClient } from "@wirevod/app-core";
import { TooltipProvider } from "@wirevod/ui";
import { RouterProvider } from "react-router";
import { router } from "./router";

const queryClient = createQueryClient();

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <RouterProvider router={router} />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
